import React from 'react';
import ConnectSection from './ConnectSection';
import SocialMediaSection from './SocialMediaSection';
var FooterBody = function() {
    return /*#__PURE__*/ React.createElement("div", {
        id: "FooterBody"
    }, /*#__PURE__*/ React.createElement(ConnectSection, null), /*#__PURE__*/ React.createElement(SocialMediaSection, null));
};
export default FooterBody;
